import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d2c2d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receive" }
const _hoisted_2 = { class: "receive-footer" }
const _hoisted_3 = {
  key: 1,
  class: "redpack-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tx_loading = _resolveComponent("tx-loading")!
  const _component_bg_slot = _resolveComponent("bg-slot")!
  const _component_layout = _resolveComponent("layout")!
  const _component_redpack_info = _resolveComponent("redpack-info")!
  const _component_personality_button = _resolveComponent("personality-button")!
  const _component_expire_ps = _resolveComponent("expire-ps")!
  const _component_share_button = _resolveComponent("share-button")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_layout, { key: 0 }, {
          other: _withCtx(() => [
            _createVNode(_component_bg_slot, null, {
              default: _withCtx(() => [
                _createVNode(_component_tx_loading, {
                  title: _ctx.redPackBasicInfo.title,
                  from: _ctx.address.show,
                  chainId: Number(_ctx.query.chainIdInit),
                  tokenName: _ctx.redPackBasicInfo.denom
                }, null, 8, ["title", "from", "chainId", "tokenName"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_layout, {
          key: 1,
          skin: _ctx.query.skin,
          class: "receive-red"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_redpack_info, {
              chainId: _ctx.query.chainIdInit,
              redPackId: _ctx.query.redPackId,
              info: _ctx.redPackBasicInfo,
              "onUpdate:info": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.redPackBasicInfo) = $event))
            }, null, 8, ["chainId", "redPackId", "info"])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.redPackReady && _ctx.walletReady)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.isRedPackAailable)
                      ? (_openBlock(), _createBlock(_component_personality_button, {
                          key: 0,
                          type: "dark",
                          loading: _ctx.openLoading,
                          onClick: _ctx.openHandler
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n("receive.open")), 1)
                          ]),
                          _: 1
                        }, 8, ["loading", "onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isRedPackAailable && !_ctx.isRedPackOwn)
                      ? (_openBlock(), _createBlock(_component_expire_ps, { key: 1 }))
                      : _createCommentVNode("", true),
                    (!_ctx.isRedPackAailable || _ctx.isRedPackOwn)
                      ? (_openBlock(), _createBlock(_component_personality_button, {
                          key: 2,
                          type: "white",
                          class: "red-pack-records",
                          onClick: _ctx.routeViewRecord
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n("receive.records")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_share_button, { onClick: _ctx.shareHandler }, null, 8, ["onClick"])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_loading)
                  ]))
            ])
          ]),
          _: 1
        }, 8, ["skin"]))
  ]))
}